import { Instagram, Phone, MapPin } from "lucide-react";

const LOGO = "/logo.png";

export default function Footer({ t }) {
  const year = new Date().getFullYear();

  const navLinks = [
    { label: t.nav.home, href: "#hero" },
    { label: t.nav.about, href: "#about" },
    { label: t.nav.services, href: "#services" },
    { label: t.nav.gallery, href: "#gallery" },
    { label: t.nav.reviews, href: "#testimonials" },
    { label: t.nav.contact, href: "#contact" },
  ];

  const handleNavClick = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      data-testid="footer"
      className="bg-[#050505] border-t border-white/6 pt-16 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-14">
          {/* Brand */}
          <div>
            <img
              src={LOGO}
              alt="Orkhan Babayev Logo"
              className="h-16 w-auto object-contain mb-4"
              data-testid="footer-logo"
            />
            <p className="text-white/60 font-body text-sm italic mb-6 leading-relaxed">
              {t.footer.tagline}
            </p>
            <a
              href="https://www.instagram.com/orkhan__babayev"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 min-h-[44px] text-white/60 hover:text-[#D4AF37] transition-colors duration-300 text-sm font-body"
              data-testid="footer-instagram"
            >
              <Instagram size={15} />
              @orkhan__babayev
            </a>
          </div>

          {/* Navigation */}
          <div>
            <p className="text-xs tracking-[0.28em] uppercase text-[#D4AF37] font-body mb-6">
              {t.footer.linksTitle}
            </p>
            <nav className="grid grid-cols-2 gap-y-3 gap-x-4">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                  className="text-white/60 hover:text-white font-body text-sm transition-colors duration-300 py-2"
                  data-testid={`footer-link-${link.label}`}
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Contact info */}
          <div>
            <p className="text-xs tracking-[0.28em] uppercase text-[#D4AF37] font-body mb-6">
              {t.footer.contactTitle}
            </p>
            <div className="space-y-4">
              <a href="tel:+994555525001" className="flex items-center gap-3 text-white/60 hover:text-white text-sm font-body min-h-[44px]">
                <Phone size={13} className="text-[#D4AF37]/70 shrink-0" />
                +994 55 552 50 01
              </a>
              <div className="flex items-start gap-3 text-white/60 text-sm font-body">
                <MapPin size={13} className="text-[#D4AF37]/55 shrink-0 mt-0.5" />
                <span>Baku Marriott Hotel Boulevard, Baku 1010, Azerbaijan</span>
              </div>
              <a
                href="tel:+994555525001"
                className="inline-flex items-center px-6 py-2.5 border border-[#D4AF37]/25 text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black hover:border-[#D4AF37] text-xs tracking-[0.22em] uppercase font-body font-medium transition-colors duration-300 mt-1"
                data-testid="footer-cta"
              >
                {t.footer.bookNow}
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/5 pt-6 pb-16 md:pb-0 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/45 font-body text-xs tracking-wider">
            &copy; {year} Orkhan Babayev. {t.footer.copyright}
          </p>
          <p className="text-white/40 font-body text-xs tracking-widest uppercase">
            {t.footer.brand}
          </p>
        </div>
      </div>
    </footer>
  );
}
